$(document).ready(function(){   
        $("table#tableRow a.tableRowLinkAlert").live('click', function(event) {
            alert($(this).attr("href"));
            return false;
        });

        $("table#tableRow a.tableRowTitleAlert").live('click', function(event) {
            alert($(this).attr("href"));
            return false;
        });

        $("table#tableRow tr td:not(:last-child)").live('click', function(event) {
            if (event.target.nodeName !== "TD") return true;
            let link = $(this).parent().find("a.tableRowLink").first()[0];
            if (!link || !link.href) return true;
            link.click();
            return true;
        })

        $("table#tableRow a").live('click', function(event) {
            return true;
                if ($(this).hasClass("ajax")) return true;
                if ($(this).hasClass("tableRowLinkAlert")) return false;
                if ($(this).hasClass("tableRowTitleAlert")) return false;
                if ($(this).hasClass("tableRowLinkConfirm")) return false;
                window.location = $(this).attr("href");
                return false;
        });        
        

        // $("table#tableRow tr").live("mouseover mouseout",function(event) {
        //     if (event.type == "mouseover")
        //         $(this).addClass("hover");
        //     else
        //         $(this).removeClass("hover");
        // });



        $("table a.tableRowLinkConfirm:not(.ajax)").live('click', function(event) {
            if (confirm($(this).attr("title"))) {
                window.location = $(this).attr("href");
            }
            return false;
        });
        
        $("a.linkConfirm > *").live('click', function(event) {
            if (confirm($(this).parent().attr("title"))) {
                window.location = $(this).parent().attr("href");
            }
            return false;
        });
        
        $("a.linkConfirm").live('click', function(event) {
            if (confirm($(this).attr("title"))) {
                window.location = $(this).attr("href");
            }
            return false;
        });        
        
        $('input.linkConfirm').live('click', function(event) {
            if (confirm($(this).attr("title"))) {
                $(this).parents("form:first").submit();
            }
            return false;
        });           
        
});

function srollTo(idElement){
    $('html,body').animate({ scrollTop: $(idElement).offset().top },'fast');
}

function validateDate(event) {
    // var input = event.target;
    // try {
    //     var date = $.datepicker.parseDate('dd.mm.yyyy', input.value);
    //     if (!date instanceof Date) return;
    //     if (1900 > date.getFullYear() || date.getFullYear() > 2050) input.value = null;
    // } catch (e) {
    //     input.value = null;
    // }
}

function registerDatePicker() {
    $("input.date").each(function() {
        $(this).datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: '1900:2050',
            dateFormat : 'dd.mm.yy'
        });
    });
}

generateFlashMessage = function(text, type) {
    var container = document.querySelector(".noty_bar");
    if (!container) {
        container = document.createElement("div");
        container.setAttribute("class", "noty_bar");
        document.body.appendChild(container);
    }
    var message = document.createElement("div");
    message.setAttribute("class", "animated slideInDown noty_message noty_message_" + type);
    message.innerText = text;
    container.appendChild(message);
    message.addEventListener("click", function() {
        this.remove();
    });
};
